class StickyAddToCartButton extends HTMLElement {
  constructor() {
    super();
    
    this.htmlElement = document.documentElement;
    this.buyButtonsWrapper = null;
    this.observer = null;
    this.toggleClassName = 'scrolled-past-addtocart';
  }

  connectedCallback() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    // Find the buy buttons wrapper (element that doesn't get repositioned)
    this.buyButtonsWrapper = document.querySelector('.buy-buttons');
    
    if (!this.buyButtonsWrapper) {
      console.warn('StickyAddToCartButton: Buy buttons wrapper not found');
      return;
    }

    // Set up the IntersectionObserver
    this.setupObserver();
  }

  setupObserver() {
    const options = {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // When the buy buttons are not intersecting and above the viewport (scrolled past)
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          this.htmlElement.classList.add(this.toggleClassName);
        } else {
          // When scrolled back to where buy buttons are visible
          this.htmlElement.classList.remove(this.toggleClassName);
        }
      });
    }, options);

    this.observer.observe(this.buyButtonsWrapper);
  }

  disconnectedCallback() {
    // Clean up observer
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    
    this.htmlElement.classList.remove(this.toggleClassName);
  }
}

customElements.define('sticky-addtocart-button', StickyAddToCartButton);
